import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Typography,
    Box,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TableContainer,
    Paper,
    Button,
    Chip,
    Slide,
    Tooltip,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import { isLockedTrackerStatus } from '../utils/trackerStatusLock';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const TrackersModal = ({ open, title, rows = [], onClose, onEdit, isAdmin = false }) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="lg"
            TransitionComponent={Transition}
            PaperProps={{
                sx: {
                    borderRadius: 3,
                    overflow: 'hidden',
                },
            }}
        >
            <DialogTitle
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    pr: 1,
                    bgcolor: 'primary.main',
                    color: 'primary.contrastText',
                }}
            >
                <Typography variant="subtitle1" fontWeight={600}>
                    {title}
                </Typography>
                <IconButton
                    onClick={onClose}
                    size="small"
                    sx={{ color: 'primary.contrastText' }}
                >
                    <CloseIcon fontSize="small" />
                </IconButton>
            </DialogTitle>

            <DialogContent
                sx={{
                    p: 2,
                    bgcolor: 'background.default',
                }}
            >
                <Typography variant="body2" color="text.secondary" mb={1}>
                    {rows.length} tracker{rows.length !== 1 ? 's' : ''} in this view.
                </Typography>

                <TableContainer
                    component={Paper}
                    sx={{
                        borderRadius: 2,
                        boxShadow: '0 4px 16px rgba(15,23,42,0.12)',
                        maxHeight: '60vh',
                    }}
                >
                    <Table size="small" stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ fontWeight: 600 }}>UIN</TableCell>
                                <TableCell sx={{ fontWeight: 600 }}>Location</TableCell>
                                <TableCell sx={{ fontWeight: 600 }}>Activity</TableCell>
                                <TableCell sx={{ fontWeight: 600 }}>Law Area</TableCell>
                                <TableCell sx={{ fontWeight: 600 }}>Due Date</TableCell>
                                <TableCell sx={{ fontWeight: 600 }}>Status</TableCell>
                                <TableCell sx={{ fontWeight: 600 }}>Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.length === 0 ? (
                                <TableRow>
                                    <TableCell colSpan={7} align="center">
                                        No trackers to display.
                                    </TableCell>
                                </TableRow>
                            ) : (
                                rows.map((row) => {
                                    const canOpenTracker = isAdmin || !isLockedTrackerStatus(row.status);
                                    return (
                                        <TableRow key={row.uniqueIdentifier} hover>
                                        <TableCell>{row.uniqueIdentifier}</TableCell>
                                        <TableCell>{row.location}</TableCell>
                                        <TableCell>{row.complianceActivity}</TableCell>
                                        <TableCell>{row.lawArea}</TableCell>
                                        <TableCell>
                                            {row.dueDate
                                                ? new Date(row.dueDate).toLocaleDateString()
                                                : '-'}
                                        </TableCell>
                                        <TableCell>
                                            <Chip
                                                label={row.status || 'Unknown'}
                                                size="small"
                                                color={
                                                    String(row.status).toLowerCase() === 'complied'
                                                        ? 'success'
                                                        : 'warning'
                                                }
                                                variant="outlined"
                                            />
                                        </TableCell>
                                        <TableCell>
                                            {canOpenTracker ? (
                                                <Tooltip title="Open in tracker view" arrow>
                                                    <IconButton
                                                        size="small"
                                                        color="primary"
                                                        onClick={() =>
                                                            onEdit(
                                                                JSON.stringify(row.uniqueIdentifier).replace(
                                                                    /"/g,
                                                                    ''
                                                                )
                                                            )
                                                        }
                                                    >
                                                        <EditIcon fontSize="small" />
                                                    </IconButton>
                                                </Tooltip>
                                            ) : (
                                                <Typography variant="caption" color="text.secondary">
                                                    Admin only
                                                </Typography>
                                            )}
                                        </TableCell>
                                    </TableRow>
                                    );
                                })
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </DialogContent>

            <DialogActions sx={{ px: 2, py: 1.5 }}>
                <Button onClick={onClose} variant="outlined" size="small">
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default TrackersModal;
